import type { TaskItem } from '@nexus/core';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../api/client';
import type { SessionInfo } from '../api/types';
import { useModules } from '../modules/context';
import type { WebModule } from '../modules/define';
import { canIn, useSession } from '../session/session';

export const myTasksQuery = queryOptions({
  queryKey: ['tasks', 'mine'],
  queryFn: ({ signal }) => api.get<{ items: TaskItem[]; more: boolean }>('/tasks/mine', { signal }),
});

export function recordTasksQuery(entity: string, recordId: string) {
  return queryOptions({
    queryKey: ['tasks', entity, recordId],
    queryFn: ({ signal }) =>
      api.get<TaskItem[]>(`/tasks?${new URLSearchParams({ entity, recordId }).toString()}`, {
        signal,
      }),
  });
}

/** Whether some active module lets the person work on tasks: shows "Für mich". */
export function canTaskIn(modules: readonly WebModule[], session: SessionInfo): boolean {
  return modules
    .filter((m) => session.modules.includes(m.manifest.id))
    .some((m) =>
      (m.manifest.activity ?? []).some(
        (a) => a.tasks !== undefined && canIn(session, a.tasks) && canIn(session, a.read),
      ),
    );
}

export function useCanTask(): boolean {
  return canTaskIn(useModules(), useSession());
}
